import Common from "../Common";

const Cfc = class extends Common {
	async browse() {
		return this.get(`/company/cfc`);
	}

	async update(
		id: id,
		data: {
			state: any,
			pbx_soundfile_id_on: id | null,
			pbx_soundfile_id_off: id | null
		}
	) {
		return this.patch(`/cfc/${id}`, data)
	}
}

export default Cfc
